import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation } from 'swiper/core';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import { toast } from 'react-toastify';
import { Button, Modal } from 'react-bootstrap';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import Select from 'react-select';
import { useLocalStorage } from 'react-use';
import CenteredSpinner from './CenteredSpinner';
import Moment from 'react-moment';
import { useDispatch } from 'react-redux';
import { singlePropertyMap } from '../redux/action';
import noImage from '../images/noimage.png';
import { Clock, Heart, MapPin, Map, Share2, UserPlus, Navigation as NavigationIcon, Image, Calendar, FileText } from 'react-feather';
import * as AppConstants from '../AppConstants';
import { getSysSetting, numberWithCommas } from '../Utils';
import { UpdateNextAvailableDateModal } from './modals/UpdateNextAvailableDateModal';
import { OwnerLastContactModal } from './modals/OwnerLastContactModal';
import { UpdateMarketStatusModal } from './modals/UpdateMarketStatusModal';
import moment from 'moment-timezone';

SwiperCore.use([Pagination, Navigation]);

export const PropertyDetails = (props) => {
  const location = useLocation();
  const [showModal, setShowModal] = useState(false);
  const [showPriceModal, setShowPriceModal] = useState(false);
  const [reason, setReason] = useState(null);
  const [comment, setComment] = useState(null);
  const queryClient = useQueryClient();
  const [reasonError, setReasonError] = useState(null);
  const [showUpdateOwnerLastContactModal, setShowUpdateOwnerLastContactModal] = useState(false);
  const [showUpdateOwnerLastContactModalQuestion, setShowUpdateOwnerLastContactModalQuestion] = useState(false);
  const [showUpdatePropertyCoordinatesModal, setShowUpdatePropertyCoordinatesModal] = useState(false);
  const [showNextAvailableModal, setShowNextAvailableModal] = useState(false);
  const [showMarketStatusModal, setShowMarketStatusModal] = useState(false);
  const [ownerContactDate, setOwnerContactDate] = useState(null);
  const [ownerContactDateError, setOwnerContactDateError] = useState(null);
  const [nextAvailableDate, setNextAvailableDate] = useState(null);
  const [nextAvailableError, setNextAvailableError] = useState(null);
  const [commentError, setCommentError] = useState(null);
  const [noteTextError, setNoteTextError] = useState(null);
  const [noteText, setNoteText] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [currentLat, setCurrentLat] = useState(null);
  const [currentLon, setCurrentLon] = useState(null);
  const [price, setPrice] = useState(null);
  const [images, setImages] = useState(null);
  const [showModalImage, setShowModalImage] = useState(false);
  const [errorImages, setErrorImages] = useState(null);
  const refImage = useRef(null);
  const [mountRefImages, setMountRefImages] = useState(null);
  const [multipleFiles, setMulitpleFiles] = useState(null);
  const [imagesFiles, setImagesFiles] = useState(null);
  const [propertyID, setPropertyID] = useLocalStorage(
    'propspropertyforsalecard',
    location?.state?.query?.property?.id,
  );
  const [userID] = useState(localStorage.getItem('userId'));
  const [staffMemberID] = useState(
    localStorage.getItem('staffMemberId'),
  );
  const [path, setPath] = useLocalStorage('Path', '');

  const [reasonDataLocalStorage, setReasonDataLocalStorage] =
    useLocalStorage('ReasonData', []);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    let token = localStorage.getItem('token');
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${token}`;

    document.title = 'Property Details';
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setPropertyID(location?.state?.query?.property?.id);
    setOwnerContactDate(moment(location?.state?.query?.property?.ownerLastContacted).toDate());
    if (
      location?.state?.prevPath?.path !== undefined ||
      location?.state?.prevPath?.path !== null
    ) {
      setPath(
        location?.state?.prevPath?.path ||
          JSON.parse(localStorage.getItem('Path')),
      );
    }

    if (
      location?.state?.query?.property !== undefined ||
      location?.state?.query?.property !== null
    ) {
      setPropertyID(
        location?.state?.query?.property?.id ||
          JSON.parse(
            localStorage.getItem('propspropertyforsalecard'),
          ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      location?.state?.prevPath?.path !== undefined ||
      location?.state?.prevPath?.path !== null
    ) {
      setPath(
        location?.state?.prevPath?.path ||
          JSON.parse(localStorage.getItem('Path')),
      );
    }

    if (
      location?.state?.query?.property !== undefined ||
      location?.state?.query?.property !== null
    ) {
      setPropertyID(
        location?.state?.query?.property?.id ||
          JSON.parse(
            localStorage.getItem('propspropertyforsalecard'),
          ),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    location?.state?.query?.property,
    location?.state?.prevPath?.path,
  ]);

  const fetchPropertyDetailsByID = (id) => {
    const options = {
      method: 'GET',
      url: `/property/getsummary/${id}`,
    };

    return axios
      .request(options)
      .then((response) => {

        //Retrieve Property Images
        const options2 = {
          method: 'GET',
          url: `/externalfile/GetByRecordContextType/${id}/3/1`, //3 is Property Document Context, 1 is FileType Image
        };

        return axios
          .request(options2)
          .then((response2) => {
            response.data.externalFiles = response2.data;
            console.log(response.data);
            return response.data;
          })
          .catch((error) => {});

      })
      .catch((error) => {});
  };

  const {
    isLoading: isLoadingPropertyDetails,
    data: dataPropertyDetails,
    refetch
  } = useQuery(
    ['propertydetails', propertyID],
    () => fetchPropertyDetailsByID(propertyID),
    {
      enabled: Boolean(propertyID),
    },
  );

  const reasonModal = (id) => {
    setShowModal(true);
    setPropertyID(id);
  };

  const priceModal = () => {
    if (dataPropertyDetails.forSaleOrToLet === false) {
      //Is for sale
      setPrice(dataPropertyDetails?.propertyForSale?.price.toString());
    } else {
      //Is to let
      setPrice(dataPropertyDetails?.propertyToLet?.longLetRate.toString());
    }
    setShowPriceModal(true);
  };

  const propertyUpdateCoordinatesModal = () => {
    setShowUpdatePropertyCoordinatesModal(true);
  };

  const uploadImagesModal = () => {
    setShowModalImage(true);
  };

  const nextAvailableModal = () => {
    setNextAvailableError(null);
    setShowNextAvailableModal(true);
  };

  const handleAddBuyerProperties = () => {
    navigate('/AddBuyerProperties', {
      state: {
        propertyId: propertyID,
      }
    })
  };

  const updateOwnerLastContactModal = () => {
    setShowUpdateOwnerLastContactModal(true);
  };

  const handleReasonChange = (event) => {
    setReasonError(null);
    setReason(event.value);
  };

  const handleComment = (e) => {
    setCommentError(null);
    setComment(e.target.value);
  };

  const handlePriceAutoComplete = () => {
    let priceMoney;
    if (price !== null && price !== '') {
      priceMoney = price
        .replace(/[ ,.]/g, '')
        .replace(/[K|k]/g, '*1000')
        .replace(/[M|m]/g, '*1000000')
        .replace(/[^0-9/*.]/g, '');

      var args = priceMoney.split('*');
      priceMoney = args.reduce((a, b) => a * b);
      let returnVal = numberWithCommas(priceMoney);
      setPrice(returnVal);
      return;
    }
    setPrice('');
  };

  const handlePriceChange = (e) => {
    setPrice(e.target.value.trim());
  };

  const handleUpdateOwnerLastContact = async (e) => {
    setDisabled(true);
    e.preventDefault();
    e.stopPropagation();
    if (!noteText) {
      setNoteTextError("Note Text input can't be empty");
      setDisabled(false);
      return;
    }

    const config = {
      method: 'POST',
      url: '/property/updateownerlastcontact',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        lastContactDate: ownerContactDate,
        noteText: noteText,
        staffMemberId: staffMemberID,
        username: localStorage.getItem('username')
      }),
    };

    try {
      const data = await axios(config);

      if (data.status === 200) {
        setNoteText(null);
        setDisabled(false);
        toast.success(
          `Owner last contact date has been updated.`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            draggable: true,
            progress: undefined,
          },
        );
        refetch();
      }
    } catch (err) {
      setDisabled(false);
      toast.error(
        `Sorry, property wasn't added, try again ${err.message}`,
        {
          position: 'top-left',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
      throw new Error(`server error`);
    }
    setReason(null);
    setComment(null);
    setShowModal(false);

    setShowUpdateOwnerLastContactModal(false);
  };

  const handleUpdateOwnerLastContactQuestion = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    let d = new Date();
    let isoDate = d.toLocaleString('en-US');

    const config = {
      method: 'POST',
      url: '/property/updateownerlastcontact',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        lastContactDate: isoDate,
        noteText: 'Updated by price or availability date change.',
        staffMemberId: staffMemberID,
        username: localStorage.getItem('username')
      }),
    };

    try {
      const data = await axios(config);

      if (data.status === 200) {
        setDisabled(false);
        toast.success(
          `Property last contact date has been updated`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            draggable: true,
            progress: undefined,
          },
        );
        //Trigger manual refetch
        refetch();
      }
    } catch (err) {
      setDisabled(false);
      toast.error(
        `Error ${err.message}`,
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
      throw new Error(`server error`);
    }
    setShowUpdateOwnerLastContactModalQuestion(false);
  };

  const handleUpdatePropertyCoordinates = async () => {
    const config = {
      method: 'POST',
      url: '/Property/UpdatePropertyCoordinates',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        Id: propertyID,
        GoogleMapLatitude: currentLat,
        GoogleMapLongitude: currentLon,
        UsernameSubmitted: localStorage.getItem('username')
      }),
    };

    try {
      const data = await axios(config);

      if (data.status === 200) {
        toast.success(
          `Property Coordinates Updated`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            draggable: true,
            progress: undefined,
          },
        );
        //Trigger manual refetch
        refetch();
      }
    } catch (err) {
      setDisabled(false);
      toast.error(
        `We are still determining your coordinates, please try again.`,
        {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        },
      );
    }
    setShowUpdatePropertyCoordinatesModal(false);
  };

  const handleUpdatePropertyPrice = async () => {
    const config = {
      method: 'POST',
      url: '/Property/UpdatePropertyPrice',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        Id: propertyID,
        PriceSQ: price,
        AmendmentByStaffId: localStorage.getItem('staffMemberId'),
        UsernameSubmitted: localStorage.getItem('username')
      }),
    };

    try {
      const data = await axios(config);

      if (data.status === 200) {
        toast.success(
          `Property Price Updated`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            draggable: true,
            progress: undefined,
          },
        );
        //Trigger manual refetch
        refetch();
        setShowUpdateOwnerLastContactModalQuestion(true);
      }
    } catch (err) {

    }
    setShowPriceModal(false);
  };

  const handleUploadPropertyImages = async () => {
    let ftc = dataPropertyDetails?.propertyRef.substring(0, 2);
    let ffc = dataPropertyDetails?.propertyRef.substring(0, 4);
    if (disabled == true) return false;

    setDisabled(true);

    if (multipleFiles !== null) {
      const payload = await Promise.all(
        multipleFiles.map(async (file) => {
          var base64Image = file.data.replace(
            /^data:image\/[a-z]+;base64,/,
            '',
          );

          var dotIndex = file.filename.lastIndexOf('.');
          var ext = file.filename
            .substring(dotIndex)
            .toUpperCase()
            .replace(/\./g, '');

          var imagePath = `Property\\P${ftc}\\P${ffc}\\P${dataPropertyDetails?.propertyRef}\\O_${dataPropertyDetails?.propertyRef}_${file.filename}`;

          var ImagesRequestOptions = {
            method: 'POST',
            url: `/property/createanduploadpropertyextfile`,
            headers: {
              'Content-Type': 'application/json',
            },
            data: JSON.stringify({
              Base64File: `${base64Image}`,
              MetaData: {
                RecordId: 0,
                FileType: 1,
                Rating: 0,
                SequenceNo: 99,
                FileExtension: `${ext}`,
                FilePath: `${imagePath}`,
                Description: `Image Uploaded From Mobile`,
              },
              FileName: `${file.filename}.jpg`,
              PropertyRef: `${dataPropertyDetails?.propertyRef}`,
            }),
          };

          try {
            return await axios(ImagesRequestOptions);
          } catch (err) {}
        }),
      );

      if (payload) {
        toast.success(`Images Uploaded Successfully`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      setDisabled(false);
      setShowModalImage(false);
    }
  };

  const addFavourite = async (e, propertyRef) => {
    setDisabled(true);
    if (!reason) {
      setReasonError("Reason input can't be emptied");
      setDisabled(false);
      return;
    }
    if (!comment) {
      setCommentError("Comment input can't be emptied");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    queryClient.invalidateQueries('Favourites');

    let d = new Date();
    let isoDate = d.toLocaleString('en-US');

    const config = {
      method: 'POST',
      url: '/propertyfavourite',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify({
        propertyId: propertyID,
        sys_UserId: userID,
        dateRegistered: isoDate,
        propertyFavouriteReasonId: reason,
        comments: comment,
      }),
    };

    try {
      const data = await axios(config);
      if (data.status === 201) {
        setReason(null);
        setComment(null);
        setDisabled(false);
        toast.success(`Property: ${propertyRef} has been added`, {
          position: 'top-center',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,

          draggable: true,
          progress: undefined,
        });
      }
    } catch (err) {
      if (err)
        toast.error(
          `Sorry, property wasn't added, try again ${err.message}`,
          {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
    }
    setReason(null);
    setComment(null);
    setShowModal(false);
  };

  const fetchReason = () => {
    const options = {
      method: 'GET',
      url: `/propertyfavouritereason`,
    };

    return axios
      .request(options)
      .then((response) => {
        let options = response.data.map((element) => {
          return { value: element.id, label: element.description };
        });
        return options;
      })
      .catch((error) => {});
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data: reasonData } = useQuery(['Reason'], fetchReason,
  { refetchOnWindowFocus: false }
  );

  useEffect(() => {
    setReasonDataLocalStorage(reasonData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reasonData]);

  const initialValue = '';

  const handleMobileNos = (numbers) => {
    var result = [];
    numbers.forEach(element => {
      result.push(<a href={'tel:' + element.prefix + element.telephoneNo}>{element.prefix + '-' + element.telephoneNo + ' '}</a>);
    });
    return result;
  };

  const mutation = useMutation(handleUpdateOwnerLastContact, {
    onMutate: async (id) => {
      await queryClient.cancelQueries('propertydetails');
      const previousValue = queryClient.getQueryData(
        ['propertydetails', id.id],
        {
          exact: false,
        },
      );

      let d = new Date();
      let isoDate = d.toLocaleString('en-US');

      const updatedValue = { ...previousValue };

      queryClient.setQueryData(['propertydetails', id.id], {
        ...updatedValue,
        ownerLastContacted: isoDate,
      });

      return { previousValue };
    },
    onError: (err, _id, context) => {
      queryClient.setQueryData(
        ['propertydetails', _id.id],
        context.previousValue,
      );
    },
  });

  const handleMap = (dataPropertyDetails, searchPath) => {
    navigate('/MapPerCard');
    dispatch(
      singlePropertyMap({
        property: dataPropertyDetails,
        searchPath: searchPath,
      }),
    );
  };

  const handleImgDownload = (url, filename) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const getCurrentLocation = function () {
    return new Promise(function (resolve, reject) {
      navigator.geolocation.getCurrentPosition(resolve, reject);
    });
  };

  const handleDeleteImage = (id) => {
    setImages((oldState) =>
      oldState.filter((item, index) => index !== id),
    );

    refImage.current.files = mountRefImages;

    const dt = new DataTransfer();
    Array.from(refImage.current.files).forEach((filev, index) => {
      if (id !== index) {
        dt.items.add(
          new File([filev], filev.name, { type: filev.type }),
        );
      }
    });

    let fileObj = [];

    fileObj.push(dt.files);

    setMountRefImages(dt.files);

    if (fileObj < 0) {
      return;
    }

    tobase64Handler(dt.files).then((data) => {
      setMulitpleFiles(data);
    });

    refImage.current.files = dt.files;
  };

  const tobase64Handler = async (files) => {
    const filePathsPromises = [];
    Array.from(files).forEach((file) => {
      filePathsPromises.push(toBase64(file));
    });
    const filePaths = await Promise.all(filePathsPromises);
    return filePaths;
  };
  
  //multiple images
  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve({ data: reader.result, filename: file.name });
      reader.onerror = (error) => reject(error);
    });
  };

  const handleUploadMultipleFiles = (e) => {
    e.persist();
    e.preventDefault();
    let fileObj = [];
    let fileArray = [];

    refImage.current.files = e.target.files ?? mountRefImages;

    fileObj.push(e.target.files);
    for (let i = 0; i < fileObj[0].length; i++) {
      if (fileObj[0][i].type !== 'image/jpeg') {
        setErrorImages((prevState) => ({
          ...prevState,
          type: 'Only images can be uploaded',
        }));
      }
      if (fileObj[0][i].size >= 10485760) {
        setErrorImages((prevState) => ({
          ...prevState,
          size: 'File too Big, please select a file less than 10mb',
        }));
      }
      fileArray.push(URL.createObjectURL(fileObj[0][i]));
    }

    setImages(fileArray);

    setImagesFiles([...fileObj]);

    if (e.target.files < 0 || !e.target.validity.valid) {
      return;
    }

    // refImage.current.files = e.target.files;
    tobase64Handler(e.target.files).then((data) => {
      setMulitpleFiles(data);
    });

    setMountRefImages(e.target.files);
  };

  const handleUpdateNextAvailableDate = async (e) => {
    setDisabled(true);
    if (!nextAvailableDate) {
      setNextAvailableError("Date is required");
      setDisabled(false);
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    let data = {
      PropertyId: parseInt(propertyID),
      LettingNextAvail: moment(nextAvailableDate).utc(true)
    };

    const config = {
      method: 'POST',
      url: '/Property/UpdatePropertyLettingNextAvail',
      headers: {
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(data),
    };

    try {
      const data = await axios(config);
      if (data.status == 200 || data.status == 201) {
        setDisabled(false);
        toast.success(
          `Next Available Date Updated`,
          {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            draggable: true,
            progress: undefined,
          },
        );
        setShowNextAvailableModal(false);
        //Trigger manual refetch
        refetch();
        setShowUpdateOwnerLastContactModalQuestion(true);
      }
    } catch (err) {
      if (err.response.status === 500)
      setComment('');
      setDisabled(false);
    }
  };

  useEffect(() => {
    getCurrentLocation()
      .then((position) => {
        setCurrentLat(position.coords.latitude);
        setCurrentLon(position.coords.longitude);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  if (isLoadingPropertyDetails) {
    return <CenteredSpinner />;
  }

  const isToLet = dataPropertyDetails?.forSaleOrToLet === true;
  const canShowMap =
    dataPropertyDetails?.googleMapLatitude !== null &&
    dataPropertyDetails?.googleMapLongitude !== null;
  const imageFiles =
    location?.state?.property?.externalFiles?.length > 0
      ? location?.state?.property?.externalFiles
      : dataPropertyDetails?.externalFiles || [];
  const priceLabel =
    dataPropertyDetails?.forSaleOrToLet === false
      ? numberWithCommas(dataPropertyDetails?.propertyForSale?.price)
      : numberWithCommas(dataPropertyDetails?.propertyToLet?.longLetRate) +
        ' ' +
        dataPropertyDetails?.propertyToLet?.leaseRatePeriod;
  const heroTitle =
    dataPropertyDetails?.shortDescription ||
    dataPropertyDetails?.propertyTypeName ||
    'Property Details';
  const heroSubtitle =
    dataPropertyDetails?.shortDescription &&
    dataPropertyDetails?.propertyTypeName
      ? dataPropertyDetails?.propertyTypeName
      : null;

  return (
    <div className="container p-0 mb-4">
      <div className="property-actions-shell property-details-shell">
        <div className="property-actions-hero">
          <div className="property-hero-row property-hero-row--top">
            <div className="property-hero-left">
              {dataPropertyDetails?.propertyRef ? (
                <span className="badge badge-light text-uppercase">
                  Ref {dataPropertyDetails?.propertyRef}
                </span>
              ) : null}
              <span className="badge badge-light text-uppercase">
                {dataPropertyDetails?.forSaleOrToLet === false ? 'For Sale' : 'To Let'}
              </span>
            </div>
            <div className="property-hero-right">
              <button
                type="button"
                className="btn btn-sm property-actions-back"
                onClick={() => navigate(-1)}
              >
                <i className="fas fa-arrow-left me-2"></i>
                Back
              </button>
            </div>
          </div>

          <div className="property-hero-row property-hero-row--mid">
            <div className="property-hero-title">
              {heroTitle}
            </div>
          </div>

          {heroSubtitle ? (
            <p className="mb-1 text-white-50 small property-hero-subtitle">{heroSubtitle}</p>
          ) : null}

          <div className="property-hero-row property-hero-row--address">
            <p className="mb-0 text-white-50 text-capitalize property-hero-location">
              {dataPropertyDetails?.localityName}
              {dataPropertyDetails?.addressLine1 ? ` - ${dataPropertyDetails?.addressLine1}` : ''}
            </p>
            <div className="property-hero-price">
              € {priceLabel}
            </div>
          </div>

          <div className="property-actions-quick">
            {isToLet && dataPropertyDetails?.propertyToLet?.lettingNextAvail ? (
              <span className="pill">
                <Clock size={14} className="mr-1" />
                {moment(dataPropertyDetails.propertyToLet.lettingNextAvail).format('DD/MM/YYYY')}
              </span>
            ) : null}
            <span className="pill">
              <i className="fas fa-bed mr-1"></i>
              {dataPropertyDetails?.bedrooms ?? '-'}
            </span>
            {dataPropertyDetails?.areaSqMtrs ? (
              <span className="pill">
                <i className="fas fa-expand mr-1"></i>
                {dataPropertyDetails?.areaSqMtrs} SqMtrs
              </span>
            ) : null}
            <span className="pill">
              {dataPropertyDetails?.marketStatusCode || 'Not set'}
            </span>
            <button
              type="button"
              className="pill pill-button"
              onClick={() => setShowMarketStatusModal(true)}
              title="Update market status"
              aria-label="Update market status"
            >
              Update
            </button>
          </div>
        </div>

        <div className="property-actions-body">
          <div className="property-actions-gallery">
            {imageFiles.length === 0 ? (
              <img src={noImage} alt="defaultImage" className="img-fluid w-100 rounded" />
            ) : (
              <Swiper
                slidesPerView={1}
                navigation
                pagination={{
                  dynamicBullets: true,
                }}
              >
                {imageFiles
                  ?.map((file) => ({
                    url: `${AppConstants.BASE_URL_FILE + file.filePath}`,
                  }))
                  .map((slideImage, index) => (
                    <SwiperSlide key={index}>
                      <div className="property-actions-image">
                        <img src={slideImage.url} alt="slider" className="img-fluid w-100" />
                        <a
                          href={slideImage.url}
                          download={`image-${index}.jpg`}
                          target="_blank"
                          rel="noreferrer"
                          className="property-actions-open-link"
                        >
                          Open
                        </a>
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
            )}
          </div>
          <div className="property-actions-sidebar">
            <div className="property-actions-grid">
              {canShowMap ? (
                <button
                  className="property-actions-chip"
                  onClick={() => {
                    handleMap(dataPropertyDetails, location?.state?.prevPath?.path);
                  }}
                  title="Open map"
                >
                  <Map size={18} />
                  <span>Map</span>
                </button>
              ) : null}

              {canShowMap ? (
                <a
                  className="property-actions-chip"
                  href={
                    'https://www.google.com/maps/search/?api=1&query=' +
                    dataPropertyDetails?.googleMapLatitude +
                    ',' +
                    dataPropertyDetails?.googleMapLongitude
                  }
                  target="_blank"
                  rel="noreferrer"
                  title="Open in Google Maps"
                >
                  <NavigationIcon size={18} />
                  <span>Navigate</span>
                </a>
              ) : null}

              {path !== '/Favourites' && path !== '/HotProperties' ? (
                <button
                  className="property-actions-chip"
                  onClick={(e) => {
                    reasonModal(dataPropertyDetails?.id);
                    e.stopPropagation();
                  }}
                  title="Add to favourites"
                >
                  <Heart size={18} />
                  <span>Favourite</span>
                </button>
              ) : null}

              <button
                className="property-actions-chip"
                onClick={handleAddBuyerProperties}
                title="Add to buyer"
              >
                <UserPlus size={18} />
                <span>Add buyer</span>
              </button>

              <button className="property-actions-chip" onClick={uploadImagesModal} title="Upload images">
                <Image size={18} />
                <span>Upload</span>
              </button>

              <button
                className="property-actions-chip"
                onClick={propertyUpdateCoordinatesModal}
                title="Update coordinates"
              >
                <MapPin size={18} />
                <span>Set coords</span>
              </button>

              <button className="property-actions-chip" onClick={priceModal} title="Update price">
                <span>€ Price</span>
              </button>

              {dataPropertyDetails?.publishToWebsite === true && dataPropertyDetails?.showingOnWeb === true ? (
                <a
                  className="property-actions-chip"
                  href={`https://wa.me/?text=${encodeURI(
                    getSysSetting(AppConstants.SysSettingId_PropertyWebUrl)?.stringValue +
                      dataPropertyDetails.propertyRef,
                  )}`}
                  target={'_blank'}
                  rel="noreferrer"
                  title="Share website"
                >
                  <Share2 size={18} />
                  <span>Share web</span>
                </a>
              ) : null}

              {dataPropertyDetails?.webReportUrl ? (
                <a
                  className="property-actions-chip"
                  href={`https://wa.me/?text=${encodeURI(dataPropertyDetails.webReportUrl)}`}
                  target={'_blank'}
                  rel="noreferrer"
                  title="Share report"
                >
                  <FileText size={18} />
                  <span>Report</span>
                </a>
              ) : null}

              <button
                className="property-actions-chip"
                onClick={() => updateOwnerLastContactModal(dataPropertyDetails?.id)}
                title="Owner last contact"
              >
                <Calendar size={18} />
                <span>Last contact</span>
              </button>

              {isToLet ? (
                <button
                  className="property-actions-chip"
                  onClick={nextAvailableModal}
                  title="Next available date"
                >
                  <Calendar size={18} />
                  <span>Availability</span>
                </button>
              ) : null}
            </div>

            <div className="property-actions-meta">
              <div className="property-actions-meta-item">
                <span className="label">Location</span>
                <p className="mb-1">{dataPropertyDetails?.addressLine1}</p>
                <p className="mb-1">{dataPropertyDetails?.addressLine2}</p>
                <p className="mb-0">{dataPropertyDetails?.addressLine3}</p>
              </div>
              {dataPropertyDetails?.shortDescription !== null ? (
                <div className="property-actions-meta-item">
                  <span className="label">Property short name</span>
                  <p className="mb-0">{dataPropertyDetails?.shortDescription}</p>
                </div>
              ) : null}
              <div className="property-actions-meta-item d-flex align-items-center justify-content-between">
                <div>
                  <span className="label d-block">Owner last contact</span>
                  <Moment format="DD/MM/YYYY">{dataPropertyDetails?.ownerLastContacted}</Moment>
                </div>
                <Button
                  variant="light"
                  size="sm"
                  className="btn-update-owner"
                  onClick={() => updateOwnerLastContactModal(dataPropertyDetails?.id)}
                >
                  Update
                </Button>
              </div>
              {dataPropertyDetails?.internalComments !== null &&
              dataPropertyDetails?.internalComments.length > 100 ? (
                <div className="property-actions-meta-item">
                  <span className="label">Internal comments</span>
                  <p
                    className="mb-0 small break-word"
                    dangerouslySetInnerHTML={{
                      __html: dataPropertyDetails?.internalComments,
                    }}
                  ></p>
                </div>
              ) : null}
            </div>
          </div>
        </div>

        <div className="property-details-sections">
          {dataPropertyDetails?.shortDescription !== null ? (
            <div className="property-details-card">
              <h6>Owner</h6>
              {dataPropertyDetails?.vendorAddressList?.map(function (vendor, index) {
                return vendor?.mainOwner === true ? (
                  <div className="mb-3" key={index}>
                    <p className="font-weight-bold mb-1">{`${vendor?.ownerName}`}</p>
                    {vendor?.address?.addressPhones?.length ? (
                      <div className="mb-2">
                        <span className="property-details-label">
                          {vendor?.address?.addressPhones.length > 1 ? 'Telephones' : 'Telephone'}
                        </span>
                        <div>{handleMobileNos(vendor?.address?.addressPhones)}</div>
                      </div>
                    ) : null}

                    {vendor?.address?.addressEmails?.map(function (email, emailIndex) {
                      return (
                        <div className="mb-1" key={emailIndex}>
                          <span className="property-details-label">
                            {vendor?.address?.addressEmails.length > 1 ? 'Emails' : 'Email'}
                          </span>
                          <a href={`mailto:${email?.emailAddress}`} className="text-primary">
                            {email?.emailAddress}
                          </a>
                        </div>
                      );
                    })}
                    <div className="mb-2">
                      <span className="property-details-label">Last contacted</span>
                      <Moment format="DD/MM/YYYY">{dataPropertyDetails?.ownerLastContacted}</Moment>
                    </div>
                    <div className="mb-1">
                      <span className="property-details-label">Viewings by</span>
                      <span>{dataPropertyDetails?.viewingsBy}</span>
                    </div>
                    <div className="mb-1">
                      <span className="property-details-label">Agent</span>
                      <span>{dataPropertyDetails?.viewingNegotiatorName}</span>
                    </div>

                    {dataPropertyDetails?.viewingsBy === 'KeysAtOffice' ? (
                      <div className="mb-1">
                        <span className="property-details-label">Keys</span>
                        <div>
                          {dataPropertyDetails?.propertyKeys?.map(function (value, keyIndex) {
                            if (value.keyStatus != 'Withdrawn') {
                              return (
                                <span key={keyIndex}>
                                  {value?.keyRef?.split('_')[1] + value?.tagNo}{' '}
                                </span>
                              );
                            }
                            return null;
                          })}
                        </div>
                      </div>
                    ) : null}
                  </div>
                ) : null;
              })}
              <p className="font-weight-bold mb-1">
                {dataPropertyDetails?.vendorAddressList?.addressIndividualSurname}
              </p>
              <p className="font-weight-bold mb-0">{dataPropertyDetails?.ownerPhonesString}</p>
            </div>
          ) : null}

          <div className="property-details-card">
            <h6>Property Key Features</h6>
            {isToLet ? (
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div>
                  <span className="property-details-label">Availability</span>
                  <Moment format="DD/MM/YYYY">
                    {dataPropertyDetails?.propertyToLet?.lettingNextAvail}
                  </Moment>
                </div>
                <Button className="btn-update-owner" size="sm" onClick={nextAvailableModal}>
                  Update
                </Button>
              </div>
            ) : null}
            <div className="mb-1">
              <span className="property-details-label">Bedrooms</span>
              <span>{dataPropertyDetails?.bedrooms}</span>
            </div>
            <div className="mb-1">
              <span className="property-details-label">Area</span>
              <span>{dataPropertyDetails?.areaSqMtrs} SqMtrs</span>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-0">
              <div>
                <span className="property-details-label">Market status</span>
                <span>{dataPropertyDetails?.marketStatusCode || 'Not set'}</span>
              </div>
              <Button
                className="btn-update-owner"
                size="sm"
                onClick={() => setShowMarketStatusModal(true)}
              >
                Update
              </Button>
            </div>
          </div>

          {dataPropertyDetails?.propertyDescription !== null ? (
            <div className="property-details-card">
              <h6>Property Description</h6>
              <div
                dangerouslySetInnerHTML={{
                  __html: dataPropertyDetails?.propertyDescription,
                }}
              ></div>
            </div>
          ) : null}
        </div>
      </div>
      <Modal show={showModal} backdrop="static" centered dialogClassName="property-modal">
        <Modal.Header
          closeButton
          onClick={() => {
            setReason(null);
            setReasonError(null);
            setCommentError(null);
            setShowModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Add To Favourites</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label className="form-label mb-2" htmlFor="reason">
            Reason:
          </label>
          <Select
            id="reason"
            className={`${reasonError && 'react-select'}`}
            classNamePrefix={`${reasonError && 'react-select'}`}
            onChange={handleReasonChange}
            isSearchable={true}
            options={reasonDataLocalStorage}
          />
          {reasonError && (
            <small
              className="text-danger"
              style={{ display: 'block' }}
            >
              {reasonError}
            </small>
          )}
          <label
            className="form-label block mb-2 mt-2"
            htmlFor="comments"
          >
            Comments:
          </label>
          <input
            id="comments"
            autoComplete="off"
            className={`form-control d-block w-100 ${
              commentError && 'border-danger'
            }`}
            type="text"
            value={comment}
            onChange={handleComment}
            name="comment"
            required
          />
          {commentError && (
            <small className="text-danger">{commentError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant={
              comment !== null && disabled === true
                ? 'success'
                : 'primary'
            }
            onClick={(event) =>
              addFavourite(event, dataPropertyDetails.propertyRef)
            }
            disabled={comment !== null && disabled === true}
          >
            {comment !== null && disabled === true
              ? 'Adding...'
              : 'Add'}
          </Button>
        </Modal.Footer>
      </Modal>

      <OwnerLastContactModal
        showModal={showUpdateOwnerLastContactModal}
        noteTextError={noteTextError}
        setNoteText={setNoteText}
        setNoteTextError={setNoteTextError}
        setShowModal={setShowUpdateOwnerLastContactModal}
        ownerContactDate={ownerContactDate}
        setOwnerContactDate={setOwnerContactDate}
        ownerContactDateError={ownerContactDateError}
        disabled={disabled}
        updateOwnerLastContact={handleUpdateOwnerLastContact}
      />

      <Modal
        show={showUpdateOwnerLastContactModalQuestion}
        backdrop="static"
        centered
        dialogClassName="property-modal"
      >
        <Modal.Header
          closeButton
          onClick={() => {
            setShowUpdateOwnerLastContactModalQuestion(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Owner Contacted Today</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label
            className="form-label block mb-2 mt-2"
            htmlFor="NoteText"
          >
            Have you contacted the owner of the property?
          </label>
          {noteTextError && (
            <small className="text-danger">{noteTextError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
        <Button
            variant='danger'
            onClick={() => {
              setShowUpdateOwnerLastContactModalQuestion(false);
            }}
          >
            No
          </Button>
          <Button
            variant={
              noteText !== null && disabled === true
                ? 'success'
                : 'primary'
            }
            onClick={(event) => {
              handleUpdateOwnerLastContactQuestion(event)
            }}
          >
            {noteText !== null && disabled === true
              ? 'Updating...'
              : 'Yes'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUpdatePropertyCoordinatesModal}
        backdrop="static"
        centered
        dialogClassName="property-modal"
      >
        <Modal.Header
          closeButton
          onClick={() => {
            setShowUpdatePropertyCoordinatesModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Update Property Location</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label
            className="form-label block mb-2 mt-2"
          >
            Are you sure you want to set current location as property coordinates?
          </label>
        </Modal.Body>
        <Modal.Footer>
        <Button
            variant='danger'
            onClick={() => {
              setShowUpdatePropertyCoordinatesModal(false);
            }}
          >
             No
          </Button>
          <Button
            variant='primary'
            onClick={(event) =>
              handleUpdatePropertyCoordinates(event)
            }
          > 
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPriceModal} backdrop="static" centered dialogClassName="property-modal">
        <Modal.Header
          closeButton
          onClick={() => {
            setPrice(null);
            setShowPriceModal(false);
          }}
        >
          <Modal.Title><span className='font-weight-bold'>Update Property Price</span></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label
            className="form-label block mb-2 mt-2"
            htmlFor="price"
          >
            New price:
          </label>
          <input
            id="price"
            autoComplete="off"
            className={`form-control d-block w-100 ${
              commentError && 'border-danger'
            }`}
            type="text"
            value={price}
            onChange={handlePriceChange}
            onBlur={handlePriceAutoComplete}
            name="price"
            placeholder="100k"
            required
          />
          {commentError && (
            <small className="text-danger">{commentError}</small>
          )}
        </Modal.Body>
        <Modal.Footer>
        <Button
            variant='danger'
            onClick={() => {
              setShowPriceModal(false);
            }}
          >
             Cancel
          </Button>
          <Button
            variant='primary'
            onClick={(event) =>
              handleUpdatePropertyPrice(event)
            }
          > 
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showModalImage} centered backdrop="static" dialogClassName="property-modal">
            <Modal.Header
              closeButton
              onClick={() => {
                setShowModalImage(false);
                setErrorImages(null);
              }}
            >
              <Modal.Title><span className='font-weight-bold'>Upload Property Images</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {images !== null ? (
                <>
                  <div className="grid-container-images">
                    {(images || []).map((url, index) => (
                      <img
                        key={index}
                        src={url}
                        alt="property images"
                        height="200px"
                        style={{ objectFit: 'cover' }}
                        className=""
                        onClick={() => handleDeleteImage(index)}
                      />
                    ))}
                  </div>
                  <br />
                  {images !== null && images.length > 0 ? (
                    <button
                      onClick={() => {
                        setImages(null);
                        setMulitpleFiles(null);
                        setErrorImages(null);
                      }}
                      className="mt-2 mb-2 btn btn-primary"
                    >
                      {images.length > 1
                        ? 'Remove all images'
                        : 'Remove image'}
                    </button>
                  ) : null}
                </>
              ) : null}
              <p>
                {images?.length > 0
                  ? errorImages && errorImages.type
                  : null}
              </p>
              <p>
                {images?.length > 0
                  ? errorImages && errorImages.size
                  : null}
              </p>
              <br />
              <div className="form-group">
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => handleUploadMultipleFiles(e)}
                  accept="image/*"
                  multiple
                  ref={refImage}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant='danger'
                onClick={() => {
                  setShowModalImage(false);
                }}
              >
                Cancel
              </Button>
              {multipleFiles !== null && multipleFiles.length > 0 ? (
                <button
                  onClick={() => {
                    handleUploadPropertyImages();
                  }}
                  className="mt-2 mb-2 btn btn-primary"
                >
                  {disabled === true
                  ? 'Saving...'
                  : 'Save'}
                </button>
              ) : null}
            </Modal.Footer>
          </Modal>
          <UpdateNextAvailableDateModal
            showModal={showNextAvailableModal}
            setNextAvailableError={setNextAvailableError}
            setShowModal={setShowNextAvailableModal}
            nextAvailableDate={nextAvailableDate}
            setNextAvailableDate={setNextAvailableDate}
            nextAvailableError={nextAvailableError}
            disabled={disabled}
            updateNextAvailableDate={handleUpdateNextAvailableDate}
        />
        <UpdateMarketStatusModal
          showModal={showMarketStatusModal}
          setShowModal={setShowMarketStatusModal}
          propertyId={propertyID}
          currentStatusCode={dataPropertyDetails?.marketStatusCode}
          onSuccess={refetch}
        />
    </div>
  );
};
